import * as ReactDOM from "react-dom/client";
import {RouterProvider} from "react-router-dom";
import {Loader, MantineProvider} from "@mantine/core";
import {Notifications} from "@mantine/notifications";
import {Provider} from "react-redux";
import {store} from "./app/store/store";
import {ModalsProvider} from "@mantine/modals";
import {PropsWithChildren, Suspense} from "react";
import {useOtsColorSchemePreference} from "@ots-frontend/ots-ui-tw";
import {AppRouter} from "./app/routes/AppRouter";
import {themeOverride} from "./theme-override";

// localize
import "./i18n";

// css
import "@glideapps/glide-data-grid/dist/index.css";
import '@ag-grid-community/styles/ag-grid.css';
import '@ag-grid-community/styles/ag-theme-quartz.css';
import '@sendbird/uikit-react/dist/index.css';
import '@xyflow/react/dist/style.css';
import '@fontsource-variable/inter';
import '@fontsource-variable/lexend';
import './main.css'

/** Mantine follows the same light/dark choice as the Tailwind side of the app. */
const ThemedMantineProvider = ({children}: PropsWithChildren) => {
  const {colorScheme} = useOtsColorSchemePreference();
  return (
    <MantineProvider theme={{...themeOverride, colorScheme}} withGlobalStyles={true} withNormalizeCSS={true}>
      {children}
    </MantineProvider>
  );
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <Provider store={store}>
    <ThemedMantineProvider>
      <ModalsProvider>
        <Notifications position="top-right"/>
        <Suspense fallback={<Loader/>}>
          <RouterProvider router={AppRouter}/>
        </Suspense>
      </ModalsProvider>
    </ThemedMantineProvider>
  </Provider>
);
